import request from '@/utils/request'
let dicMap = window.sessionStorage;
let obj = {};

function dictionaries(id) {
  return request({
    url: '/dict/findPage',
    method: 'post',
    data: {
      pageNo: "1",
      pageSize: "99",
      id: id
    }
  })
}

function diction(resolve, reject, key, val) {
  if (key == "nd") {
    let date = new Date();
    let year = date.getFullYear();
    let ndArr = [];
    let dicMap = window.sessionStorage;
    for (let i = 0; i < 5; i++) {
      ndArr.push({
        label: year - i,
        value: year - i
      });
    }
    dicMap.setItem("nd", JSON.stringify(ndArr));
    resolve(ndArr);
  } else if (key == "syqlx") {
    let arr = [{
        label: "村集体",
        value: "1"
      },
      {
        label: "国有",
        value: "2"
      },
      {
        label: "集体",
        value: "3"
      },
      {
        label: "合作社",
        value: "4"
      },
      {
        label: "自然人",
        value: "5"
      }
    ];
    dicMap.setItem("syqlx", JSON.stringify(arr));
    resolve(arr);
  } else if (key == "dw") {
    let arr = [{
        label: "平方米",
        value: "1"
      },
      {
        label: "亩",
        value: "2"
      },
      {
        label: "米",
        value: "3"
      },
      {
        label: "个",
        value: "4"
      },
      {
        label: "股",
        value: "5"
      },
      {
        label: "只",
        value: "6"
      },
      {
        label: "棵",
        value: "7"
      },
      {
        label: "株",
        value: "8"
      },
      {
        label: "辆",
        value: "9"
      },
      {
        label: "暂无",
        value: "10"
      }
    ];
    dicMap.setItem("dw", JSON.stringify(arr));
    resolve(arr);
  } else {
    dictionaries(key).then(res => {
      let data = res.data;
      if (data.success) {
        let arr = data.msg.data.map(i => {
          i.label = i.name;
          i.value = i.code;
          return i
        });
        dicMap.setItem(key, JSON.stringify(arr));
        if (val) {
          let res;
          res = arr.filter(i => {
            return i.value == val
          });
          if (res.length) {
            res = res[0].label
          } else {
            res = val
          }
          resolve(res);
        } else {
          resolve(arr);
        }
      } else {
        reject();
      }
    }).catch(res => {
      console.log("失败'")
    })
  }
}

export function doCreate(key) {
  return new Promise((resolve, reject) => {
    if (dicMap.getItem(key)) {
      resolve(JSON.parse(dicMap.getItem(key)));
    } else {
      diction(resolve, reject, key);
    }
  });
}

export function getDicTab(key, val) {
  return new Promise((resolve, reject) => {
    let res;
    if (val === null || val === undefined) resolve("");
    if (dicMap.getItem(key)) {
      res = JSON.parse(dicMap.getItem(key)).filter(i => {
        return i.value == val
      });
      if (res.length) {
        res = res[0].label
      } else {
        res = val
      }
      resolve(res);
    } else {
      diction(resolve, reject, key, val);
    }
  });
}
export function handleEmpty(data) {
  data.map(i => {
    if (i.children.length) {
      handleEmpty(i.children)
    } else {
      delete i.children;
    }
  })
  return data;
}

export function handleNextCode(code, myCode, data) {
  let data2 = [];
  if (code == myCode.substring(0, 2) && code.length < myCode.length) { //省级
    data.map(d => {
      if (d.code == myCode.substring(0, 4)) {
        data2.push(d);
        console.log(data2)
        return data2;
      }
    });
  } else if (code == myCode.substring(0, 4) && code.length < myCode.length) { //市级
    data.map(d => {
      if (d.code == myCode.substring(0, 6)) {
        data2.push(d);
        return data2;
      }
    });
  } else if (code == myCode.substring(0, 6) && code.length < myCode.length) { //县级
    data.map(d => {
      if (d.code == myCode.substring(0, 9)) {
        data2.push(d);
        return data2;
      }
    });
  } else if (code == myCode.substring(0, 9) && code.length < myCode.length) { //镇级
    data.map(d => {
      if (d.code == myCode.substring(0, 12)) {
        data2.push(d);
        return data2;
      }
    });
  } //点击区划小于等于登录人区划，直接赋值
  else {
    data2 = data;
  }
  return data2;
}
export function moreMenu(val, data, childrenData) {
  if (data.length == 0) {
    return childrenData;
  } else {
    let len = data.filter(x => {
      return x.code == val;
    }).length;
    if (len) {
      data.map(c => {
        if (c.code == val) {
          c.children = childrenData;
          return c;
        }
      });
    } else {
      data.map(c => {
        if (c.children && c.children.length) {
          c.children = moreMenu(val, c.children, childrenData);
        }
        return c;
      });
    }
    return data;
  }
}
export function gpjgdwMap(val) {
  if (val) {
    return {
      "1": "元(总价)",
      "2": "元/年",
      "3": "元/亩/年",
      "4": "元/亩",
      "5": "元/平方米/年",
      "6": "元/平方米/天",
      "7": "元/米/年",
      "8": "元/吨"
    } [val];
  }
  return "";
}
//函数防抖（debounce）
let timeout = null
let timer = null
let start = 0

export const debounce = (func, delay) => {
  if (timeout !== null) clearTimeout(timeout)
  timeout = setTimeout(func, delay)
}


//函数节流(Throttle)
export const Throttle = (func, wait, trailing) => {
  let now = new Date()
  if ((now - start) >= wait) {
    timer && clearTimeout(timer)
    timer = null
    start = now
    return func()
  } else if (!timer && trailing) {
    timer = setTimeout(() => {
      timer = null
      return func
    }, wait)
  }
}



// WEBPACK FOOTER //
// ./src/utils/config.js